/**
 * StockCard 헬퍼 컴포넌트 및 유틸리티
 */
import React from 'react';

// 리스크 레벨 계산
export const getRiskLevel = (level: number): { icon: string; label: string } => {
  if (level <= 3) return { icon: 'LOW', label: 'LOW' };
  if (level <= 6) return { icon: 'MED', label: 'MED' };
  return { icon: 'HIGH', label: 'HIGH' };
};

// 신호 아이콘
export const getSignalIcon = (signal: number): string => {
  if (signal > 0) return '+';
  if (signal < 0) return '-';
  return '=';
};

// 신호 레이블
export const getSignalLabel = (signal: number): string => {
  if (signal > 0) return 'BUY';
  if (signal < 0) return 'SELL';
  return 'HOLD';
};

export const getSignalClass = (signal: number): string => {
  if (signal > 0) return 'buy';
  if (signal < 0) return 'sell';
  return 'hold';
};

// 개별 신호 아이템
interface SignalItemProps {
  name: string;
  signal: number;
}

export const SignalItem: React.FC<SignalItemProps> = ({ name, signal }) => (
  <span className={`signal-item ${getSignalClass(signal)}`}>
    <span className="signal-name">{name}:</span>
    <span className="signal-icon">{getSignalIcon(signal)}</span>
    <span className="signal-strength">{getSignalLabel(signal)}</span>
  </span>
);

// 검증 배지
interface VerificationBadgesProps {
  alpacaValid?: boolean;
  alpacaName?: string;
  alpacaExchange?: string;
  catalystVerified?: boolean;
  catalystConfidence?: number;
  catalystSentiment?: string;
  ticker: string;
}

export const VerificationBadges: React.FC<VerificationBadgesProps> = ({
  alpacaValid, alpacaName, alpacaExchange, catalystVerified, catalystConfidence, catalystSentiment, ticker
}) => (
  <div className="verification-badges">
    {alpacaValid !== undefined && (
      <div className={`badge ${alpacaValid ? 'badge-success' : 'badge-error'}`} title={alpacaName || ticker}>
        {alpacaValid ? 'Ticker 확인' : 'Ticker 오류'}
        {alpacaExchange && <span className="badge-detail"> ({alpacaExchange})</span>}
      </div>
    )}
    {catalystVerified !== undefined && (
      <div
        className={`badge ${catalystVerified
          ? catalystConfidence && catalystConfidence >= 60 ? 'badge-success' : 'badge-warning'
          : 'badge-neutral'}`}
        title={`뉴스 일치: ${catalystConfidence || 0}%, 감정: ${catalystSentiment || 'neutral'}`}
      >
        News {catalystConfidence !== undefined && `${catalystConfidence}%`}
      </div>
    )}
  </div>
);

// 정보 섹션 (catalyst, market_summary, why_now, source_hint)
interface InfoSectionProps {
  label: string;
  text: string;
  className: string;
}

export const InfoSection: React.FC<InfoSectionProps> = ({ label, text, className }) => (
  <div className={className}>
    <div className={`${className}-label`}>{label}</div>
    <div className={`${className}-text`}>{text}</div>
  </div>
);
